import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";
import { useQuery } from "convex/react";
import { api } from "../../../../../convex/_generated/api";

interface MessageButtonProps {
  currentUserId?: string;
}

export function MessageButton({ currentUserId }: MessageButtonProps) {
  // Get live unread message count from Convex
  const unreadCount = useQuery(api.messages.getUnreadMessageCount) || 0;

  return (
    <Button variant="ghost" size="icon" className="relative" asChild>
      <Link to="/messages">
        <MessageSquare className="h-5 w-5 text-gray-600" />
        {unreadCount > 0 && (
          <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-red-500"></span>
        )}
      </Link>
    </Button>
  );
}
